import { useEffect, useState } from 'react';
import { listAuditLogs, type AuditEntry } from '../api/client';
import { Icon } from '../components/Icon';

export function AuditTrail() {
  const [rows, setRows] = useState<AuditEntry[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    listAuditLogs().then((r) => setRows(r.items)).catch((err: Error) => setError(err.message));
  }, []);

  return (
    <>
      <div className="page-head">
        <div>
          <span className="eyebrow">
            <Icon name="audit" size="xs" />
            <span>Immutable Compliance Evidence</span>
          </span>
          <h1>System Audit Trail</h1>
        </div>
        <span className="muted mono" style={{ fontSize: 12 }}>Append-only ledger. Zero tamper capability.</span>
      </div>
      {error && <div className="banner error">{error}</div>}
      <div className="panel">
        <div className="table-responsive">
          <table>
            <thead>
              <tr>
                <th style={{ width: 200 }}>Timestamp</th>
                <th style={{ width: 220 }}>Action</th>
                <th style={{ width: 130 }}>Module</th>
                <th>Reason / Metadata</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan={4} className="empty">No audit entries recorded yet.</td>
                </tr>
              ) : (
                rows.map((entry) => (
                  <tr key={entry.id}>
                    <td className="mono">{new Date(entry.created_at).toLocaleString('en-IN')}</td>
                    <td><strong>{entry.action}</strong></td>
                    <td className="muted">{entry.module}</td>
                    <td className="muted">{entry.reason ?? '—'}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
